import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { toggleProduct } from 'swag-client-common/redux/goodie-giveaway/actions/goodie-giveaway-selection.actions';
import { isRemoveSelectedGoodieProductPopupShownSelector, popupParamsSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { selectedGiveawayColorWithFallbackSelector } from '../../../../giveaway/redux/giveaway-landing/giveaway-landing.selectors';
import { RemoveGoodieProductPopup as Component } from './remove-goodie-product-popup';
const productSelector = createSelector(popupParamsSelector, params => params === null || params === void 0 ? void 0 : params.product);
const linkSelector = createSelector(popupParamsSelector, params => params === null || params === void 0 ? void 0 : params.link);
const mapStateToProps = createStructuredSelector({
  open: isRemoveSelectedGoodieProductPopupShownSelector,
  product: productSelector,
  link: linkSelector,
  buttonColor: selectedGiveawayColorWithFallbackSelector
});
const mapDispatchToProps = dispatch => ({
  onConfirm: (product, link) => {
    dispatch(toggleProduct(product, link));
    dispatch(hidePopup());
  },
  onClose: () => {
    dispatch(hidePopup());
  }
});
export const RemoveGoodieProductPopup = connect(mapStateToProps, mapDispatchToProps)(Component);